/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Not Found Resource Revision Problem schema.
 */
export interface ProblemResourceRevisionNotFound {
    /** Similar to kubernetes `resourceVersion` and `generation` field to identify the object version. */
    actual: number;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string;
    /** Optional list of individual error details */
    errors?: Truvity.ErrorDetail[];
    expected: Truvity.Resource;
    /** A URI reference that identifies the specific occurrence of the problem. */
    instance?: string;
    /** HTTP status code */
    status: number;
    /** This value should not change between occurrences of the error. */
    title: string;
}
